// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"42521426","36":"46f2b2a7","122":"ad72d079","162":"2415278d","343":"bc43a7a7","486":"4e7753d0","721":"363cd3d7","809":"210623e1","953":"e7c9ede3"}[chunkId] + ".chunk.js";
};